export default "__VITE_PUBLIC_ASSET__6e9c188f__"